import * as React from "react";
import { styled, alpha } from "@mui/material";

import { makeStyles } from "@mui/styles";
import Color from "color";

export const useStyles = makeStyles((theme) => ({
  paper: {
    // backgroundColor: theme.palette.primary.main,
    color: theme.palette.text.tertiary,
    textAlign: "center",
    height: theme.spacing(13),
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    overflow: "hidden",
    paddingRight: theme.spacing(4),
  },

  cardContentsWrapper: {
    display: "flex",
    flexDirection: "row",
    // justifyContent: "space-around",
    alignItems: "center",
    // padding: theme.spacing(40)
  },

  cardHeaderTextWrapper: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",

    color: theme.palette.text.tertiary,
    margin: theme.spacing(0, "10%"),
  },

  secondBgIcon: {
    height: theme.spacing(25),
    fontSize: theme.spacing(13),
    opacity: ".4",
    position: "relative",
    left: theme.spacing(5),
    transition: theme.transitions.duration.fancy,

    // "&:hover": {
    //   fontSize: theme.spacing(18),
    // },
    // left:theme.spacing(1),
  },

  cardHeader: {
    margin:0,
    fontSize: theme.spacing(1.5),
    color: theme.palette.text.tertiary,
  },

  cardText: {
    fontWeight: "500",
    fontSize:theme.spacing(3),
    margin:"0",
    color: theme.palette.text.tertiary,
  },
}));
